import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c1c66562")
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "cooperation-content" }
const _hoisted_3 = { class: "title-menu" }
const _hoisted_4 = {
  key: 0,
  class: "title-title"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "lager-font" }, "我的资源", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "swipe-wrap"
}
const _hoisted_8 = {
  key: 0,
  class: "shadow1"
}
const _hoisted_9 = {
  key: 1,
  class: "shadow2"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "right" }
const _hoisted_12 = { class: "farming-task-add" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "right-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "新增农事记录"),
  /*#__PURE__*/_createElementVNode("div", null, "基地种植溯源信息")
], -1)
const _hoisted_14 = { class: "title-line" }
const _hoisted_15 = { class: "title-content" }
const _hoisted_16 = {
  key: 0,
  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/renwu.png"
}
const _hoisted_17 = {
  key: 1,
  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/renwu-1.png"
}
const _hoisted_18 = {
  key: 2,
  class: "noti"
}
const _hoisted_19 = {
  key: 0,
  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/jilu.png"
}
const _hoisted_20 = {
  key: 1,
  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/renwu-2.png"
}
const _hoisted_21 = { class: "filter-menu" }
const _hoisted_22 = { class: "tab-content" }
const _hoisted_23 = {
  key: 1,
  class: "null-wrap"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "null-card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "还没有农事任务哦～")
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 2 }
const _hoisted_27 = {
  key: 0,
  class: "record-wrap"
}
const _hoisted_28 = { class: "line_1" }
const _hoisted_29 = { class: "info" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  class: /*#__PURE__*/_normalizeClass({ menus: true, 'start-move': true })
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "line_2" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { class: "line_3" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "line_4" }
const _hoisted_41 = { class: "poster-wrap" }
const _hoisted_42 = {
  key: 0,
  class: "line_6"
}
const _hoisted_43 = { class: "other" }
const _hoisted_44 = { class: "other" }
const _hoisted_45 = {
  key: 1,
  class: "null-wrap"
}
const _hoisted_46 = { class: "null-card" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "还没有农事记录哦，来增加一条吧～", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_farming_task = _resolveComponent("farming-task")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_preview_video = _resolveComponent("preview-video")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.loading = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.selectedCooperation ? _ctx.selectedCooperation.cooperationName : ""), 1),
            _createElementVNode("a", {
              class: "right-text",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSwitch && _ctx.onSwitch(...args)))
            }, "切换")
          ]),
          (_ctx.resourceData.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true)
        ]),
        (_ctx.resourceData.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.resourceData.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.resourceData.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                : _createCommentVNode("", true),
              _createVNode(_component_van_swipe, {
                class: "my-swipe",
                "show-indicators": false,
                onChange: _ctx.onSourceChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resourceData, (item) => {
                    return (_openBlock(), _createBlock(_component_van_swipe_item, {
                      key: item.id,
                      style: {"border-radius":"0.625rem"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "land-container",
                          onClick: ($event: any) => (_ctx.onClickSource(item))
                        }, [
                          _createVNode(_component_van_image, {
                            radius: "8px",
                            src: 
                  item.images.length > 0
                    ? item.images[0].url + '?imageView2/1/w/200/h/200/rotate/0'
                    : 'https://qnui.xfarmer.com/xfarmer-ui/public/default_source.png'
                ,
                            class: "left",
                            onClick: ($event: any) => (_ctx.onPreview(item.images, 0))
                          }, null, 8, ["src", "onClick"]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", null, _toDisplayString(item.sourceName), 1),
                            _createElementVNode("div", null, "预计产量：" + _toDisplayString(item.yield) + "斤", 1),
                            _createElementVNode("div", null, [
                              _createVNode(_component_van_image, {
                                src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/nonghu.png",
                                class: "num"
                              }),
                              _createTextVNode(_toDisplayString(item.farmerInfo.farmerName), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", null, _toDisplayString(item.addressInfo), 1),
                              _createElementVNode("span", null, [
                                _createVNode(_component_van_image, {
                                  class: "icons",
                                  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/weizhi.png"
                                }),
                                _createTextVNode(" " + _toDisplayString(item.distance) + "km ", 1)
                              ])
                            ])
                          ])
                        ], 8, _hoisted_10)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["onChange"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "inner-content",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRecordFarming && _ctx.onRecordFarming(...args)))
          }, [
            _createVNode(_component_van_image, {
              class: "left-img",
              src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/task.png"
            }),
            _hoisted_13
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: _normalizeClass({ task: true, 'selected-menu': _ctx.tagType === 'task' }),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickTask && _ctx.onClickTask(...args)))
            }, [
              (_ctx.tagType === 'task')
                ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                : _createCommentVNode("", true),
              (_ctx.tagType === 'record')
                ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                : _createCommentVNode("", true),
              (_ctx.outTimeDataCount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, " +" + _toDisplayString(_ctx.outTimeDataCount), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass({ record: true, 'selected-menu': _ctx.tagType === 'record' }),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickRecord && _ctx.onClickRecord(...args)))
            }, [
              (_ctx.tagType === 'task')
                ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                : _createCommentVNode("", true),
              (_ctx.tagType === 'record')
                ? (_openBlock(), _createElementBlock("img", _hoisted_20))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]),
        (_ctx.tagType === 'task')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", {
                    class: _normalizeClass({
                'tab-item': true,
                'tab-select-item': _ctx.filterActive === 0,
              })
                  }, [
                    _createElementVNode("span", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onActiveChange(0)))
                    }, "待操作")
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass({
                'tab-item': true,
                'tab-select-item': _ctx.filterActive === 1,
              })
                  }, [
                    _createElementVNode("span", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onActiveChange(1)))
                    }, "已操作")
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass({
                'tab-item': true,
                'tab-select-item': _ctx.filterActive === 2,
              })
                  }, [
                    _createElementVNode("span", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onActiveChange(2)))
                    }, "已忽略")
                  ], 2)
                ])
              ]),
              (_ctx.farmingDataList.length > 0)
                ? (_openBlock(), _createBlock(_component_van_list, {
                    key: 0,
                    class: "list-wrap",
                    finished: _ctx.taskTotal === _ctx.farmingDataList.length,
                    "finished-text": "我已经到底了~~~"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmingDataList, (item) => {
                        return (_openBlock(), _createBlock(_component_farming_task, {
                          key: item.id,
                          datas: item,
                          onUpdate: _ctx.onUpdateTask,
                          sourceId: _ctx.sourceId,
                          types: "add"
                        }, null, 8, ["datas", "onUpdate", "sourceId"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["finished"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              (_ctx.recordList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_component_van_list, {
                      class: "record-content",
                      finished: _ctx.recordTotal === _ctx.recordList.length,
                      "finished-text": "我已经到底了~~~"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordList, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "card-item",
                            key: item
                          }, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_van_image, {
                                class: "icons",
                                src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/point.png"
                              }),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", null, _toDisplayString(item.workTimeStr), 1),
                                _createElementVNode("div", null, [
                                  _createTextVNode(" #" + _toDisplayString(item.areaCode), 1),
                                  (item.areaName)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, "-" + _toDisplayString(item.areaName), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_component_van_image, {
                                  class: "more",
                                  src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/more.png",
                                  onClick: ($event: any) => (_ctx.onShowMenu(item))
                                }, null, 8, ["onClick"]),
                                _withDirectives(_createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", {
                                    class: "right-btn del",
                                    onClick: ($event: any) => (_ctx.onDeleteRecord(item))
                                  }, " 删除 ", 8, _hoisted_32),
                                  _createElementVNode("div", {
                                    class: "right-btn edit",
                                    onClick: ($event: any) => (_ctx.onEditRecord(item))
                                  }, " 编辑 ", 8, _hoisted_33)
                                ], 512), [
                                  [_vShow, item.showMenu]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              (item.farmingName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(item.farmingName), 1))
                                : _createCommentVNode("", true),
                              (item.area)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, "，完成" + _toDisplayString(item.area) + "亩", 1))
                                : _createCommentVNode("", true),
                              (item.artificial)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "，投入" + _toDisplayString(item.artificial) + "个人工", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              (item.remark)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.remark), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (items, index) => {
                                return (_openBlock(), _createBlock(_component_van_image, {
                                  class: "img-item",
                                  key: items.id,
                                  src: items.url,
                                  radius: "5px",
                                  onClick: ($event: any) => (_ctx.onPreview(item.images, index)),
                                  fit: "cover"
                                }, null, 8, ["src", "onClick"]))
                              }), 128))
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.videos, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "line_5",
                                key: item.id
                              }, [
                                _createElementVNode("div", _hoisted_41, [
                                  _createVNode(_component_van_image, {
                                    class: "poster",
                                    fit: "cover",
                                    src: item.coverImg,
                                    radius: "3px"
                                  }, null, 8, ["src"]),
                                  _createVNode(_component_van_image, {
                                    class: "play",
                                    onClick: ($event: any) => (_ctx.onPlayVideo(item)),
                                    src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/bofang.png"
                                  }, null, 8, ["onClick"])
                                ])
                              ]))
                            }), 128)),
                            (item.allZan || item.allComment)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, [
                                    _createVNode(_component_van_image, {
                                      class: "icons",
                                      src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/dianzan.png",
                                      fit: "cover"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(item.allZan), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_44, [
                                    _createVNode(_component_van_image, {
                                      class: "icons",
                                      src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/pinglun.png",
                                      fit: "cover"
                                    }),
                                    _createTextVNode(" " + _toDisplayString(item.allComment), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["finished"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("div", {
                        class: "btn",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onRecordFarming && _ctx.onRecordFarming(...args)))
                      }, "新增农事记录")
                    ])
                  ]))
            ]))
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _createVNode(_component_van_popup, {
      show: _ctx.cooperationDialog,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => (_ctx.cooperationDialog = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          value: _ctx.selectedCooperation,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedCooperation = $event)),
          title: "合作社",
          columns: _ctx.cooperationData,
          "default-index": _ctx.cooperationIndex,
          onConfirm: _ctx.onConfirm,
          onCancel: _ctx.onCancel
        }, null, 8, ["value", "columns", "default-index", "onConfirm", "onCancel"])
      ]),
      _: 1
    }, 8, ["show"]),
    (_ctx.showBack)
      ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/back.png",
          class: "back-top",
          onClick: _ctx.onBack
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_preview_video, {
      visible: _ctx.previewVideos,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (_ctx.previewVideos = $event)),
      autoplay: "",
      url: _ctx.videoUrl
    }, null, 8, ["visible", "url"])
  ]))
}